export const STEPPER_BUTTON_SIZE = 40;
export const STEPPER_RADIUS = 6;
// Digit cell is exactly 2x the side button width per Figma.
export const STEPPER_DIGIT_WIDTH = STEPPER_BUTTON_SIZE * 2;
